module.exports = __webpack_public_path__ + "static/media/detailedSubtractTennis.442c4d34.svg";